/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./external.vue?vue&type=template&id=bb1a7e86&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports